// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bu","header":"bv","message":"bw","copyMessage":"bx","button":"by"};